module.exports = __webpack_public_path__ + "static/media/img05.642727a8.png";